import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.sort.js";
import { useTrpc } from '~/composables/_next/useTrpc';
var ITEMS_PER_PAGE = 16;
export function useAdviceListingStore() {
  var _useNuxt2App = useNuxt2App(),
    i18n = _useNuxt2App.i18n;
  var route = useRoute();
  var _useTrpc = useTrpc(),
    client = _useTrpc.client;

  /**
   * Stores the current advice listing from contentful
   */
  var adviceListingContent = useState("advice-listing-".concat(route.params.slug), function () {
    return null;
  });

  /**
   * Stores the current advice listing items for dynamic listing from contentful
   */
  var adviceListingItems = useState("advice-listing-items-".concat(route.params.slug), function () {
    return null;
  });
  var adviceListingCategories = useState("advice-listing-categories-".concat(route.params.slug), function () {
    return [];
  });

  /**
   * Fetches the advice listing and related items from contentful.
   * Note: There are two cases here, one where advices are stored in a separate content type in contentful (default) which requires an
   * additional query to fetch items, and another one (custom) where the listing is available in the initial query.
   */
  function fetchAdviceListingContent(_x) {
    return _fetchAdviceListingContent.apply(this, arguments);
  }
  /**
   * Computed list of advices.
   * Note: this handles both the default and custom cases mentionned in `fetchAdviceListingContent`
   */
  function _fetchAdviceListingContent() {
    _fetchAdviceListingContent = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(forcedSort) {
      var _adviceListingSort$va, _route$query$sort, _content$data, _content$data$pageAdv, _content$data2, _content$data3, _content$data3$childr;
      var oldSort, sort, content;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            oldSort = (_adviceListingSort$va = adviceListingSort.value) === null || _adviceListingSort$va === void 0 ? void 0 : _adviceListingSort$va.selected;
            sort = (_route$query$sort = route.query.sort) !== null && _route$query$sort !== void 0 ? _route$query$sort : 'sys_firstPublishedAt_DESC';
            if (forcedSort) sort = forcedSort;
            _context.next = 5;
            return client.contentful.getAdviceListingPage.query({
              locale: i18n.locale,
              slug: route.params.slug,
              limit: ITEMS_PER_PAGE,
              skip: ITEMS_PER_PAGE * (route.query.page - 1) || 0,
              order: sort,
              categoryOrder: sort
            });
          case 5:
            content = _context.sent;
            adviceListingContent.value = content === null || content === void 0 ? void 0 : (_content$data = content.data) === null || _content$data === void 0 ? void 0 : (_content$data$pageAdv = _content$data.pageAdviceListingCollection) === null || _content$data$pageAdv === void 0 ? void 0 : _content$data$pageAdv.items[0];
            adviceListingItems.value = content === null || content === void 0 ? void 0 : (_content$data2 = content.data) === null || _content$data2 === void 0 ? void 0 : _content$data2.childrenADP;
            adviceListingCategories.value = content === null || content === void 0 ? void 0 : (_content$data3 = content.data) === null || _content$data3 === void 0 ? void 0 : (_content$data3$childr = _content$data3.childrenALP) === null || _content$data3$childr === void 0 ? void 0 : _content$data3$childr.items;
            adviceListingSort.value = getAdviceListingSort(sort);
            if (!oldSort || oldSort === sort) {
              adviceListingPagination.value = getAdviceListingPagination(adviceListingItems.value);
            }
            return _context.abrupt("return", adviceListingContent.value);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchAdviceListingContent.apply(this, arguments);
  }
  var advices = computed(function () {
    var _adviceListingItems$v;
    return (_adviceListingItems$v = adviceListingItems.value) === null || _adviceListingItems$v === void 0 ? void 0 : _adviceListingItems$v.items;
  });

  /**
   * Pagination data for the advice listing.
   */
  var adviceListingPagination = useState("advice-listing-pagination-".concat(route.params.slug), function () {
    return null;
  });

  /**
   * Gets the advice listing pagination.
   *
   * @param      {AdvicePageQuery}  adviceListingItems  The advice listing items
   * @return     {Object}           The advice listing pagination.
   */
  function getAdviceListingPagination(adviceListingItems) {
    var advicesCollection = adviceListingItems;
    var count = advicesCollection === null || advicesCollection === void 0 ? void 0 : advicesCollection.total;
    var total = Math.ceil(count / ITEMS_PER_PAGE);
    return {
      total: total,
      count: count
    };
  }

  /**
   * Sorting options for the advice listing.
   */
  var adviceListingSort = useState("advice-listing-sort-".concat(route.params.slug), function () {
    return null;
  });
  var adviceListingSortOptions = [{
    id: 'sys_firstPublishedAt_DESC',
    value: 'sys_firstPublishedAt_DESC',
    label: i18n.t('sort.latest')
  }, {
    id: 'sys_firstPublishedAt_ASC',
    value: 'sys_firstPublishedAt_ASC',
    label: i18n.t('sort.oldest')
  }, {
    id: 'title_ASC',
    value: 'title_ASC',
    label: i18n.t('sort.alphabeticalAscending')
  }, {
    id: 'title_DESC',
    value: 'title_DESC',
    label: i18n.t('sort.alphabeticalDescending')
  }];

  /**
   * Gets the advice listing sort.
   *
   * @param      {string}  sort    The sort
   * @return     {Object}  The advice listing sort.
   */
  function getAdviceListingSort(sort) {
    return {
      options: [].concat(adviceListingSortOptions),
      selected: sort !== null && sort !== void 0 ? sort : 'latest'
    };
  }

  /**
   * SEO Content for the advice listing.
   */
  var adviceListingSeoContent = useState("advice-listing-seo-".concat(route.params.slug), function () {
    return null;
  });

  /**
   * Computes an array of related advice objects based on the data in `productListingContent`
   */
  var relatedAdvices = computed(function () {
    var _adviceListingContent, _adviceListingContent2, _adviceListingContent3, _adviceListingContent4;
    var result = (_adviceListingContent = (_adviceListingContent2 = adviceListingContent.value) === null || _adviceListingContent2 === void 0 ? void 0 : (_adviceListingContent3 = _adviceListingContent2.associatedAdvices) === null || _adviceListingContent3 === void 0 ? void 0 : (_adviceListingContent4 = _adviceListingContent3.advicesCollection) === null || _adviceListingContent4 === void 0 ? void 0 : _adviceListingContent4.items) !== null && _adviceListingContent !== void 0 ? _adviceListingContent : [];
    return result;
  });
  return {
    adviceListingContent: adviceListingContent,
    advices: advices,
    adviceListingCategories: adviceListingCategories,
    fetchAdviceListingContent: fetchAdviceListingContent,
    adviceListingPagination: adviceListingPagination,
    adviceListingSort: adviceListingSort,
    adviceListingSeoContent: adviceListingSeoContent,
    relatedAdvices: relatedAdvices
  };
}